import axiosInstance from "../../lib/axios";

export async function getTktCategorydrp() {
  try {
    return await axiosInstance.post("TktCategory/getTktCategorydrp");
  } catch (err) {
    return err;
  }
}

// export async function getTktSubCategorydrp() {
//   try {
//     return await axiosInstance.post("TktSubCategory/getTktSubCategorydrp");
//   } catch (error) {
//     return error;
//   }
// }
export async function getTicketTypedrp() {
  try {
    return await axiosInstance.post("Ticket/getTicketTypedrp");
  } catch (error) {
    return error;
  }
}
export async function getTicketTagdrp() {
  try {
    return await axiosInstance.post("Ticket/getTicketTagdrp");
  } catch (error) {
    return error;
  }
}
export async function getTicketSeveritydrp() {
  try {
    return await axiosInstance.post("Ticket/getTicketSeveritydrp");
  } catch (error) {
    return error;
  }
}
export async function retriveTicket(payload) {
  try {
    return await axiosInstance.post("Ticket/RetriveTicket", payload);
  } catch (error) {
    return error;
  }
}
export async function updateTicket(payload) {
  try {
    return await axiosInstance.post("Ticket/UpdateTicket", payload);
  } catch (error) {
    return error;
  }
}
export async function insertTicket(payload) {
  try {
    return await axiosInstance.post("Ticket/InsertTicket", payload);
  } catch (error) {
    return error;
  }
}
// export async function getmobileName(payload) {
//   try {
//     return await axiosInstance.post("ResidentMst/RetriveResidentMstAll", payload);
//   } catch (error) {
//     return error;
//   }
// }

export async function getWardenDrp(payload){
  try{
  return await axiosInstance.post('MstEmp/getMstEmpdrp',payload);
  }catch(error){
    return error;
  }
}
